import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const steps = [
  {
    num: '01',
    title: 'Поиск',
    desc: 'ИИ анализирует более 200 000 Telegram-чатов в режиме реального времени.',
    icon: 'ri-radar-line',
  },
  {
    num: '02',
    title: 'Определение лида',
    desc: 'Система определяет, является ли сообщение реальным запросом клиента.',
    icon: 'ri-filter-3-line',
  },
  {
    num: '03',
    title: 'Персональный ответ',
    desc: 'ИИ формирует сообщение на основе контекста запроса.',
    icon: 'ri-quill-pen-line',
  },
  {
    num: '04',
    title: 'Диалог',
    desc: 'AIGAM задаёт вопросы, выявляет потребности и квалифицирует клиента.',
    icon: 'ri-chat-3-line',
  },
  {
    num: '05',
    title: 'Встреча',
    desc: 'ИИ согласовывает созвон или консультацию в удобное время.',
    icon: 'ri-calendar-event-line',
  },
  {
    num: '06',
    title: 'Передача менеджеру',
    desc: 'Вы получаете готового заинтересованного клиента.',
    icon: 'ri-user-shared-2-line',
  },
];

export default function TLHow() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 150 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 250 });
  const { containerRef: cardsRef, revealedCount: cardsRevealed } = useScrollRevealGroup<HTMLDivElement>(6);

  return (
    <section id="how" className="bg-background-50 py-20 md:py-28">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <span
            ref={labelRef}
            className={`inline-block text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}
          >
            Процесс
          </span>
          <h2
            ref={titleRef}
            className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}
          >
            Как работает AIGAM
          </h2>
          <p
            ref={descRef}
            className={`mt-4 text-[16px] md:text-[17px] text-foreground-500 leading-relaxed reveal-fade-up ${descRevealed ? 'revealed' : ''}`}
          >
            Шесть шагов от первого сигнала в чате до встречи в вашем календаре — без участия менеджера.
          </p>
        </div>

        <div ref={cardsRef} className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {steps.map((step, idx) => (
            <div
              key={step.num}
              className={`group relative rounded-2xl border border-background-200 bg-background-50 p-7 hover:border-foreground-950 hover:bg-background-950 transition-all duration-300 cursor-pointer overflow-hidden reveal-fade-up ${idx < cardsRevealed ? 'revealed' : ''}`}
              style={idx < cardsRevealed ? { transitionDelay: `${idx * 120}ms` } : undefined}
            >
              <div className="flex items-start justify-between">
                <span className="w-11 h-11 rounded-lg bg-primary-50 text-primary-500 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${step.icon} text-xl`}></i>
                </span>
                <span className="font-display text-[36px] font-extrabold text-background-200 group-hover:text-background-50/15 transition-colors leading-none">
                  {step.num}
                </span>
              </div>

              <h3 className="mt-6 font-display font-bold text-[20px] text-foreground-950 group-hover:text-background-50 transition-colors">
                {step.title}
              </h3>
              <p className="mt-2 text-[14.5px] text-foreground-500 group-hover:text-background-50/65 leading-relaxed transition-colors">
                {step.desc}
              </p>

              <span className="absolute bottom-7 right-7 w-8 h-8 rounded-full bg-background-200 text-foreground-400 group-hover:bg-primary-500 group-hover:text-background-50 flex items-center justify-center transition-all">
                <i className="ri-arrow-right-up-line"></i>
              </span>
              {idx < 5 && (
                <span className="hidden lg:block absolute top-9 -right-2.5 w-5 h-px bg-background-200"></span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}